import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../../global/commonStyle';

const RightRow = styled.div`
  cursor: pointer;
  p {
    ${Typography.body_md_medium}
    color: var(--brand-primary);
    margin: var(--space-0);
  }
`;

const ButtonBlock = styled.button`
  ${AlignCenter}
  padding: var(--space-4) var(--space-32) var(--space-4) var(--space-4);
  background: var(--background-secondary);
  border-radius: var(--border-radius-full);
  border: none;
  position: relative;
  cursor: pointer;
  .closeIcon {
    display: none;
    margin-left: var(--space-6);
  }
  p {
    margin: var(--space-0);
    ${Typography.body_md_medium}
    color: var(--text-primary);
  }
  &:hover {
    padding-right: var(--space-6);
    .closeIcon {
      display: flex;
      fill: var(--background-secondary);
      &:hover {
        background-color: var(--background-muted);
      }
    }
  }
  ${mobile_xl(css`
    padding-right: var(--space-6);
    .closeIcon {
      display: flex;
      &:hover {
        background-color: transparent;
      }
    }
  `)}
`;

const Row1 = styled.div`
  ${AlignCenter}
  max-width: 463px;
  width: 100%;
  flex-flow: row wrap;
  border-top: 0.5px solid var(--border-primary);
  padding-top: var(--space-12);
  gap: var(--space-12);
`;

const TeamMember = styled.div`
  ${FlexCenter}
  gap: var(--space-8);
`;

export { RightRow, ButtonBlock, Row1, TeamMember };
